<div class="grid col-nopad">
  <!-- -->
  <div class="col-12">
    <p-panel header="{{ 'NIVELES.LBL_RANGOSTASASUSUARIOS' | translate}}">

      <div class="grid col-nopad">
        <div class="col-12">
          <h3>{{nivel ? nivel.nombre : ''}}</h3>
        </div>

        <form [formGroup]="formulario" (ngSubmit)="guardar()" id="formProductoDesembolso" name="formProductoDesembolso" *ngIf="formulario" class="flex">

          <!-- Campos -->
          <div class="col-12 md:col-8">
            <div class="grid form-group">

              <!-- Nombre -->
              <div class="col-12 md:col-6">
                <div class="div-form">
                  <label>* {{ 'LBL_NOMBRE' | translate }}</label>
                  <input type="text" pInputText id="nombre" name="nombre" formControlName="nombre" [maxLength]="50"
                         (blur)="validarUnicoNombre(f.nombre.value)">
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                    {{ 'LBL_NOMBRE' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="!nombreValido">
                    {{ 'LBL_NOMBRE' | translate }} {{ 'LBL_INVALIDO' | translate }}
                  </div>
                </div>
              </div>

              <!-- Tasa mínima -->
              <div class="col-12 md:col-6">
                <div class="div-form">
                  <label>* {{ 'NIVELES.LBL_TASAMINIMA' | translate }}</label>
                  <input type="text" pInputText id="tasaMinima" name="tasaMinima" formControlName="tasaMinima" numero-decimal-rango-reactive
                         [entero]="3" [decimales]="6" [maxLength]="10" (blur)="validarUnicaTasa(f.tasaMinima.value)">
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tasaMinima.invalid">
                    {{ 'NIVELES.LBL_TASAMINIMA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="!tasaValida">
                    {{ 'NIVELES.LBL_TASAMINIMA' | translate }} {{ 'LBL_INVALIDO' | translate }}
                  </div>
                </div>
              </div>

              <!-- Indicador Habilitado -->
              <div class="col-12 md:col-6">
                <div class="div-form">
                  <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="false"
                              id="indicadorHabilitado"
                              name="indicadorHabilitado"
                              formControlName="indicadorHabilitado"></p-checkbox>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.indicadorHabilitado.invalid">
                    {{ 'LBL_HABILITADO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- Botones -->
          <div class="col-12 md:col-4">
            <div class="grid form-group">
              <div class="form-group col-12 mt-3" *ngIf="!guardando">
                <button pButton icon="fa fa-times" label="{{ 'BTN_LIMPIAR' | translate}}" type="button"
                        (click)="limpiar()"></button>
                <button pButton icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate}}" type="submit"></button>
              </div>
              <div class="form-group col-12" *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-fw"></i>
                <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
              </div>
            </div>
          </div>

        </form>

      </div>

      <hr>

      <!-- Tabla -->
      <div class="grid col-nopad">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas" [loading]="cargandoTabla"
                   [rows]="10" [value]="nivelesTasas" [paginator]="true"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                    class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.nombre}}</td>
                <td>{{row.tasaMinima| numero:6 }}</td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <div class="btn-group" role="group">
                    <button type="button" class="p-button btn" icon="fa fa-pencil" data-toggle="tooltip"
                            title="{{'BTN_EDITAR' | translate}}"
                            pButton (click)="editar(row)"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>


    </p-panel>
  </div>
</div>


<p-confirmDialog #cd key="niveles">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

